export default __webpack_public_path__ + "static/media/oe-5-rMAX.69806ed4.jpg";